window.addEventListener('SITE_START', () => {
  const sections = document.querySelectorAll('.crop-fullscreen');
  if (!sections.length) return;

  const $stickyContainer = document.querySelector('.sticky-container');
  const $stickyNav = $stickyContainer.querySelector('.sticky-nav');
  const $navList = $stickyNav.querySelectorAll('.__item');

  // Lenis와 ScrollTrigger의 초기화 타이밍 보정
  requestAnimationFrame(() => {
    sections.forEach(($section) => initSection($section));
    ScrollTrigger.refresh(true);

    if ($stickyContainer) stickyNavController();
    if (window.location.hash) {
      const hashId = window.location.hash;
      console.log('hash 감지됨:', hashId);

      //  Lenis가 첫 raf를 실행할 시간 확보
      // ScrollTrigger가 완전히 refresh된 뒤 실행
      setTimeout(() => {
        ScrollTrigger.refresh();
        ScrollTrigger.update(true);

        requestAnimationFrame(() => hashScroller());
      }, 300);
    }
    window.addEventListener('hashchange', hashScroller);
  });

  /**
   * URL hash 값에 해당하는 섹션으로 스크롤
   */
  function hashScroller() {
    const hashId = window.location.hash;
    if (!hashId) return;
    const trigger = ScrollTrigger.getById(hashId);

    const isDesktop = window.innerWidth >= 1024;
    const dist = isDesktop ? window.innerHeight * 0.5 : window.innerHeight;
    const to = trigger.start + dist;

    if (window.lenis) {
      // Lenis 사용 중
      window.lenis.scrollTo(to, {
        duration: 0,
        lock: true,
        onComplete: () => {
          ScrollTrigger.update();
        },
      });
    } else {
      // Lenis 미사용 시 fallback (GSAP ScrollToPlugin)
      gsap.to(window, {
        duration: 1,
        scrollTo: to,
        onComplete: () => {
          ScrollTrigger.refresh();
        },
      });
    }
  }

  /**
   * Sticky Nav Controller
   */
  function stickyNavController() {
    ScrollTrigger.create({
      trigger: $stickyContainer,
      start: 'top-=10 top',
      end: 'bottom bottom',
      onEnter: () => {
        $stickyNav.classList.add('--visible');
      },
      onLeaveBack: () => {
        $stickyNav.classList.remove('--visible');
      },
    });

    $navList.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        $navList.forEach(($el) => $el.classList.remove('--active'));
        item.classList.add('--active');

        const id = item.querySelector('a').getAttribute('href');
        const trigger = ScrollTrigger.getById(id);
        const isDesktop = window.innerWidth >= 1024;
        const dist = isDesktop ? window.innerHeight * 0.5 : window.innerHeight;
        const to = trigger.start + dist;

        gsap.to(window, { duration: 0, scrollTo: to });
        history.pushState(null, '', id);
      });
    });
  }

  /**
   * 각 섹션 초기화
   */
  function initSection($section) {
    createFrame($section);

    const $frame = $section.querySelector('.__frame .__boxed');
    const $cropWrapper = $section.querySelector('.__crop');
    const $cropImage = $cropWrapper.querySelector('.__image img');
    const $cropHeader = $cropWrapper.querySelector('.__header');

    const $sliderWrapper = $section.querySelector('.__slider');
    const $sliderHeader = $sliderWrapper.querySelector('.__header');
    const $sliderSwiper = $sliderWrapper.querySelector('.swiper');
    const nextBtn = $sliderWrapper.querySelector('.swiper-button-next');
    const prevBtn = $sliderWrapper.querySelector('.swiper-button-prev');

    // 계산용 함수
    const getDiffY = () => $section.clientHeight - $frame.clientHeight;
    const getDiffX = () => (window.innerWidth - $frame.clientWidth) / 2;
    const getScale = () => $frame.clientWidth / window.innerWidth;

    // 초기 상태 설정
    let cropValues = initCrop();
    let st = createScrollTrigger();
    setInitialStates();

    /**
     * Swiper 생성
     */
    const swiper = new Swiper($sliderSwiper, {
      slidesPerView: 'auto',
      spaceBetween: 10,
      speed: 300,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      observer: true,
      observeParents: true,
      breakpoints: {
        1024: {
          spaceBetween: 20,
        },
      },
      on: {
        beforeTransitionStart: (_swiper) => {
          const offsetX = _swiper.slidesGrid[_swiper.activeIndex];
          gsap.to($sliderHeader, { x: -offsetX, duration: 0.3, ease: 'ease' });
        },
        init: (_swiper) => {
          const total = _swiper.slides.length;
          const $page = $sliderWrapper.querySelector('.page');
          if ($page) {
            $page.querySelector('.--total').innerText = total;
            $page.querySelector('.--current').innerText = _swiper.realIndex + 1;
          }
        },
        slideChange: (_swiper) => {
          const $page = $sliderWrapper.querySelector('.page');
          if ($page) $page.querySelector('.--current').innerText = _swiper.realIndex + 1;
        },
      },
    });

    /**
     * Sticky Nav 다크모드 적용
     */
    function applyDarkState(on = false) {
      if (!on) {
        // dark mode off
        if (!$section.classList.contains('--translated')) {
          $section.classList.remove('--translated');
        }
        if ($stickyNav.classList.contains('--dark')) {
          $stickyNav.classList.remove('--dark');
        }
      } else {
        // dark mode on
        if ($section.classList.contains('--translated')) {
          $section.classList.add('--translated');
        }
        if (!$stickyNav.classList.contains('--dark')) {
          $stickyNav.classList.add('--dark');
        }
      }
    }

    /**
     * ScrollTrigger 생성
     * - 리사이즈 시 kill 후 재생성
     */
    function createScrollTrigger() {
      const isDesktop = window.innerWidth >= 1024;
      const zoomDist = window.innerHeight * 0.5;
      const pinDist = window.innerHeight * 0.5;
      const totalDist = zoomDist + pinDist;
      let cropTranslated = false;

      /** 🔹 네비게이션 활성화 */
      const activateSection = ($section) => {
        const id = $section.dataset.id;
        $navList.forEach((item) => {
          const navId = item.querySelector('a').getAttribute('href');
          item.classList.toggle('--active', navId === `#${id}`);
        });
      };
      /** 🔹 이전 섹션 활성화 */
      const activatePrevSection = ($section) => {
        const id = $section.dataset.id;
        let activeIndex = Array.from(sections).findIndex((sec) => sec.dataset.id === id);
        activeIndex = Math.max(0, activeIndex - 1);
        $navList.forEach((item, i) => item.classList.toggle('--active', i === activeIndex));
      };

      /** 🔹 공통 옵션 */
      const baseTriggerOptions = {
        trigger: $section,
        scrub: true,
        pin: true,
        id: '#' + $section.dataset.id,
        invalidateOnRefresh: true,
        onEnter: () => {
          activateSection($section);
        },
        onLeaveBack: () => {
          applyDarkState(true);
          activatePrevSection($section);
        },
      };

      const trigger = ScrollTrigger.create({
        ...baseTriggerOptions,
        start: 'top top',
        end: isDesktop ? `+=${totalDist}px` : `+=${$section.clientHeight}px`,
        onUpdate: (self) => {
          if (isDesktop) {
            /* DESKTOP */
            // 전체 구간의 {limit}%까지 제한, 0 ~ 1로 정규화
            const limit = zoomDist / totalDist;
            const clamped = Math.min(self.progress, limit);
            const progress = clamped / limit; // 최신 계산값 반영

            const { DIFF_Y, DIFF_X, SCALE, POS_Y, ROUND } = cropValues;
            const offsetY = DIFF_Y - getDiffY() * progress;
            const offsetX = DIFF_X - getDiffX() * progress;
            const offsetS = (1 - getScale()) * progress;
            const posY = POS_Y - POS_Y * progress;
            const round = ROUND - progress * ROUND;
            gsap.set($cropImage, { y: posY, scale: SCALE + offsetS });
            gsap.set($cropWrapper, {
              clipPath: `inset(${offsetY}px ${offsetX}px 0 round ${round}px ${round}px 0 0)`,
            });

            // 크롭 이후 컨텐츠 애니메이션
            const reached = progress >= 0.999;
            if (reached && !cropTranslated) {
              cropTranslated = true;
              applyTranslatedState('desktop');
            } else if (!reached && cropTranslated) {
              cropTranslated = false;
              resetTranslatedState('desktop');
            }

            applyDarkState(cropTranslated);
          } else {
            /* MOBILE */
            const progress = self.progress;
            const clampProgress = Math.min(progress * 2, 1);

            const { DIFF_Y, DIFF_X, SCALE, POS_Y, ROUND } = cropValues;
            const offsetY = DIFF_Y - getDiffY() * progress;
            const offsetX = DIFF_X - getDiffX() * clampProgress;
            const offsetS = (1 - getScale()) * clampProgress;
            const posY = POS_Y - POS_Y * progress;
            const round = ROUND - clampProgress * ROUND;
            const $desc = $section.querySelector('.__description p');

            gsap.set($desc, { opacity: 1 - clampProgress });
            gsap.set($cropImage, { y: posY, scale: SCALE + offsetS });
            gsap.set($cropWrapper, {
              clipPath: `inset(${offsetY}px ${offsetX}px 0 round ${round}px ${round}px 0 0)`,
            });

            // 크롭 이후 컨텐츠 애니메이션
            const reached = progress >= 0.6;
            if (reached && !cropTranslated) {
              cropTranslated = true;
              applyTranslatedState('mobile');
            } else if (!reached && cropTranslated) {
              cropTranslated = false;
              resetTranslatedState('mobile');
            }
            applyDarkState(cropTranslated);
          }
        },
      });

      return trigger;
    }

    /**
     * GSAP 초기 상태 설정
     */
    function setInitialStates(bp = 'desktop') {
      if (bp === 'desktop') {
        gsap.set($sliderSwiper, { opacity: 0, xPercent: 50 });
        gsap.set($sliderWrapper, { opacity: 0 });
        gsap.set($sliderHeader, { visibility: 'hidden' });
        gsap.set($cropHeader, { clearProps: 'all' });
      } else {
        gsap.set($sliderSwiper, { opacity: 0, xPercent: 50 });
        gsap.set($sliderWrapper, { opacity: 0 });
        gsap.set($cropHeader, { clearProps: 'all' });
      }
    }

    /**
     * 컨텐츠 등장 모션
     */
    function applyTranslatedState(bp = 'desktop') {
      if (bp === 'desktop') {
        const transY = $sliderHeader.getBoundingClientRect().top - $cropHeader.getBoundingClientRect().top;
        const tl = gsap.timeline({ defaults: { duration: 1, ease: 'power2.out' } });
        tl.to($sliderWrapper, { opacity: 1 })
          .to($cropHeader, { y: transY }, '<')
          .to(
            $sliderSwiper,
            {
              opacity: 1,
              xPercent: 0,
              onComplete: () => {
                gsap.set($sliderHeader, { visibility: 'visible' });
                gsap.set($cropHeader, { visibility: 'hidden' });
              },
            },
            '<'
          );
      } else {
        const tl = gsap.timeline({ defaults: { duration: 1, ease: 'power2.out' } });
        tl.to($sliderWrapper, { opacity: 1 }) //
          .to($sliderSwiper, { opacity: 1, xPercent: 0 }, '<');
      }
    }

    /**
     * 컨텐츠 원복 모션
     */
    function resetTranslatedState(bp = 'desktop') {
      if (bp === 'desktop') {
        const tl = gsap.timeline({ defaults: { duration: 0.5, ease: 'power2.inOut' } });
        tl.set($cropHeader, { visibility: 'visible' })
          .set($sliderHeader, { visibility: 'visible', opacity: 1 })
          .to($cropHeader, { opacity: 0 })
          .to($sliderWrapper, { opacity: 0 }, '<')
          .to($sliderSwiper, { onComplete: () => swiper.slideTo(0, 0) }, '<');
      } else {
        const tl = gsap.timeline({ defaults: { duration: 0.3, ease: 'power2.inOut' } });
        tl.to($sliderWrapper, { opacity: 0 }) //
          .to($sliderSwiper, { opacity: 0, onComplete: () => swiper.slideTo(0, 0) }, '<');
      }
    }

    /**
     * Crop 초기 상태 세팅
     */
    function initCrop() {
      const DIFF_Y = getDiffY();
      const DIFF_X = getDiffX();
      const SCALE = getScale();
      const reducedH = $cropImage.clientHeight * SCALE;
      const POS_Y = reducedH - $frame.clientHeight;
      const ROUND = 12;

      gsap.set($cropWrapper, {
        clipPath: `inset(${DIFF_Y}px ${DIFF_X}px 0 round ${ROUND}px ${ROUND}px 0 0)`,
      });
      gsap.set($cropImage, {
        scale: SCALE,
        transformOrigin: 'center bottom',
        y: POS_Y + 'px',
      });

      return { DIFF_Y, DIFF_X, POS_Y, SCALE, ROUND };
    }

    /**
     * Frame 생성
     */
    function createFrame($section) {
      const _frame = document.createElement('div');
      _frame.classList.add('__frame');
      _frame.setAttribute('aria-hidden', 'true');
      _frame.innerHTML = `
        <div class="container">
          <div class="__boxed --md"></div>
        </div>
      `;

      const _desc = $section.querySelector('.__description');
      _desc.insertAdjacentElement('afterend', _frame);
    }

    /**
     * Resize 대응
     */
    detectRealResize(() => {
      if (st) st.kill();
      cropValues = initCrop();
      st = createScrollTrigger();
      ScrollTrigger.refresh();
    });
  }
});
